import { Button, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { calculateDifferenceBetweenTimes } from './logic'
import ModalEndClass from '../modalConfirmation/ModalEndClass'
import { useTicket } from 'hooks/useTicket'
import { useSchedule } from 'hooks/useSchedule'
import ModalJustification from '../modalConfirmation/ModalJustification'
import { add } from 'date-fns'
import { formatDate } from 'utils'
import { useServerDate } from 'hooks/useServerDate'

const SubjectInfo = ({ startClass }) => {
    const { classStarted, infoSchedule } = useSelector((store) => store.teacher)
    const { serverDate, timeString } = useServerDate()
    const { sendEndClass, loading, sendJustification } = useTicket()
    const { getDailySchedules } = useSchedule()
    const [show, setShow] = useState({ endClass: false, justification: false })
    const [endClassInfo, setEndClassInfo] = useState(null)
    const [startingClass, setStartingClass] = useState(false)

    const handleJustify = async (data) => {
        const success = await sendJustification({ ...data, verificaciones: endClassInfo?.verificaciones })
        if (success) {
            setShow({ ...show, justification: false })
            await getDailySchedules()
        }
    }

    if (Object.keys(infoSchedule).length === 0) {
        return (
            <ModalJustification
                horarioId={endClassInfo?.horarioId}
                show={show.justification}
                onHide={() => setShow({ ...show, justification: false })}
                loading={loading}
                onJustify={handleJustify}
            />
        )
    }
    const { schedule } = infoSchedule

    const handleEndClass = async (data) => {
        const _endClassInfo = await sendEndClass(data)
        if (_endClassInfo) {
            setEndClassInfo(_endClassInfo)
            setShow({ endClass: false, justification: true })
            await getDailySchedules()
        }
    }
    const handleStartClass = async () => {
        if (isStartClassEnabled()) {
            setStartingClass(true)
            try {
                await startClass()
            } catch (error) {
            } finally {
                setStartingClass(false)
            }
        }
    }
    const isStartClassEnabled = () => {
        return formatDate(add(serverDate.current, { minutes: 15 }), 'H:i:s') >= infoSchedule.schedule.hora_inicio
    }

    return (
        <>
            <div className='mb-3' style={{ fontSize: '1.25rem' }}>
                <div className='row g-0 align-items-center justify-content-center mb-2'>
                    <div className='col-auto col-md-auto me-2'>
                        <span className='fw-medium'>Materia(s):</span>
                    </div>
                    <div className='col-auto col-md-auto'>
                        {schedule?.grupos.map((g, index) => (
                            <div key={index} style={{ lineHeight: '1.5rem' }}>
                                {g.materia_nombre} - Grupo: {g.grupo}
                            </div>
                        ))}
                    </div>
                </div>
                <div className='text-center'>
                    <span className='fw-medium'>Hora inicio:</span> {schedule?.hora_inicio.slice(0, 5)}
                    <span className='px-2'>⋅</span>
                    <span className='fw-medium'>Hora Fin:</span> {schedule?.hora_fin.slice(0, 5)}
                </div>
            </div>

            {classStarted.active ? (
                <div className='text-center fs-5 py-4'>
                    <div>Duración de la clase</div>
                    <div className='mb-3' style={{ fontSize: '3.5rem' }}>
                        {timeString ? (
                            calculateDifferenceBetweenTimes(classStarted.startClass, timeString)
                        ) : (
                            <Spinner animation='grow'>
                                <span className='visually-hidden'>Loading...</span>
                            </Spinner>
                        )}
                    </div>
                    <Button variant='blue' className='mb-3' onClick={() => setShow({ ...show, endClass: true })}>
                        Terminar clase
                    </Button>
                    <div>
                        <span
                            className='d-inline-block text-primary'
                            style={{ lineHeight: '1.5rem', width: '35rem', maxWidth: '100%' }}
                        >
                            * Si no presiona "Terminar clase" a horas "{schedule?.hora_fin.slice(0, 5)}", el sistema
                            terminará la clase automáticamente después de quince minutos
                        </span>
                    </div>
                </div>
            ) : (
                <div className='text-center'>
                    <Button
                        variant='blue'
                        onClick={handleStartClass}
                        disabled={startingClass || !isStartClassEnabled()}
                    >
                        Iniciar clase
                    </Button>
                </div>
            )}
            <ModalEndClass
                show={show.endClass}
                onHide={() => setShow({ ...show, endClass: false })}
                onEndClass={handleEndClass}
                loading={loading}
            />
        </>
    )
}
export default SubjectInfo
